import React, {useEffect, useState} from 'react';

import ChildContext from "./ChildContext";
import {getMyChildren} from "root/DataFunctions/ChildDataFns";

const ChildProvider = (props) => {

    const [activeChildId, setActiveChild] = useState(null) ;
    const [child, setChild] = useState('') ;
    const [ childList, setChildList] = useState ( { loading: true, items : [] } ) ;

    const getMyChildrenLocal = () =>
    {
        getMyChildren('active',(response) => {
            setChildList ( { loading: false, items: response.rows })
        });
    }

    return (
        <ChildContext.Provider
            value={{
                activeChildId: activeChildId,
                setActiveChild: ( child_id ) =>
                {
                    setActiveChild ( child_id );
                },
                childName: child.firstname + ' ' + child.surname,

                setChild: ( currentChild ) =>
                {
                    setChild ( currentChild );
                },
                childFirstName: child.firstname,
                myChildData: child,

                getMyChildren: () =>{
                    getMyChildrenLocal();
                },
                isMyChildrenLoading: childList.loading,
                myChildrenData: childList.items,

            }}
        >
            {props.children}
        </ChildContext.Provider>
    )
}

export default ChildProvider;